export function updateFontSizes(
  html,
  { elementsGerais, nameProducts, nameComplements, observation }
) {
  const parser = new window.DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  function updateElementsFontSize(selector, addValue) {
    doc.querySelectorAll(selector).forEach((el) => {
      const classList = Array.from(el.classList);
      const fontSizeClass = classList.find((c) => c.startsWith('font--size-'));
      if (fontSizeClass) {
        const currentSize =
          parseInt(fontSizeClass.replace('font--size-', ''), 10) || 0;
        const newSize = currentSize + addValue;
        el.classList.remove(fontSizeClass);
        el.classList.add(`font--size-${newSize}`);
      }
    });
  }

  updateElementsFontSize('.header', elementsGerais);
  updateElementsFontSize('.product', nameProducts);
  updateElementsFontSize('.complement', nameComplements);

  doc.querySelectorAll('.observation').forEach((el) => {
    if (observation) {
      console.log('observation', observation);
      el.style.color = '#fff';
    } else {
      console.log('no observation', observation);
      el.style.backgroundColor = 'transparent';
      el.style.color = '#000';
      el.classList.remove('font--weight-700');
    }
  });

  doc.querySelectorAll('.quantity').forEach((el) => {
    if (elementsGerais >= 4) {
      el.style.gap = '21px';
      el.style.width = '90%';
    }
  });

  return doc.body.innerHTML;
}
